import React from "react";
import { Image } from "semantic-ui-react";

const AppImage = (props) => {
  return <Image {...props} />;
};

export default AppImage;
